import { render, staticRenderFns } from "./fccAlteracoesCandidatos.vue?vue&type=template&id=19e014b8"
import script from "./fccAlteracoesCandidatos.vue?vue&type=script&lang=js"
export * from "./fccAlteracoesCandidatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports